module.exports = __webpack_public_path__ + "img/category_346.1d4091d5.jpg";